import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.response.use(
  (response) => {
    try {
      if (response.request.responseURL?.includes("countLock")) {
        window.location.href = `${process.env.REACT_APP_API_URL}/countLock`;
        return {
          ...response,
          data: {
            data: {}
          }
        };
      }

      return response;
    } catch {
      console.log("Error during parsing");
      return response;
    }
  },
  (error) => {
    console.log(error);
  }
)

export default instance;
